export default __webpack_public_path__ + "static/media/devops.5341fe58.png";